export default __webpack_public_path__ + "static/life-banner-fdc5d03e23b05ae95c1406860dda2b1c.png";